import React, { useEffect, useState } from 'react'
import Row from './TableRow';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { cloneDeep } from 'lodash';
import { getUserData, showToast } from 'services/utils';
import { isISODateString, removeMatchingItems } from '../services';

const Rows = (props) => {
    const { rows, columns, renders, config, errorRef } = props
    const [_, forceUpdate] = useState({});
    const render = () => (forceUpdate({}))
    renders.allRows = render

    const { onDelete, onSubmit, rendersRows, userData, multipleESign, dependencyFields, titleActions = false, actions = false } = config

    const deleteRow = (rowIndex) => {
        rendersRows.rows.splice(rowIndex, 1)
        rows.splice(rowIndex, 1)
        rendersRows.allRows()
    }

    const checkValidation = (row, rowIndex) => {
        let errors = {};

        columns?.forEach((column) => {
            if (column?.type === "esign") return;

            if (!!Object.hasOwn(column, "validation")) {
                const { required, msg, pattern, patternMsg } = column?.validation;
                if (required) {
                    if (multipleESign !== false && column?.eSignStep !== row?.currentESignStep) {
                        return;
                    }
                    const fieldValue = row?.[column?.uniqueName];
                    let isValidate = true;

                    if (typeof fieldValue === "string") {
                        isValidate = fieldValue.trim().length > 0;
                    } else if (typeof fieldValue === "object" && fieldValue !== null) {
                        if (column?.type === "file") {
                            if (Array.isArray(fieldValue)) {
                                isValidate = fieldValue.length > 0;
                            } else {
                                isValidate = !!fieldValue.name || !!fieldValue.size;
                            }
                        } else { isValidate = Object.keys(fieldValue).length > 0 }
                    } else {
                        isValidate = false;
                    }

                    if (isValidate && pattern && typeof fieldValue === "string") {
                        const parts = pattern.match(/^\/(.*)\/([gimsuy]*)$/);
                        const matchPattern = parts ? parts[1] : "";
                        const flags = parts?.[2] || "";
                        const regex = new RegExp(matchPattern, flags);
                        const isValid = regex.test(fieldValue);

                        if (!isValid) {
                            errors[rowIndex] = {
                                ...errors[rowIndex],
                                [column.uniqueName]: {
                                    error: true,
                                    msg: patternMsg
                                }
                            };
                        }
                    } else if (!isValidate) {
                        errors[rowIndex] = {
                            ...errors[rowIndex],
                            [column.uniqueName]: {
                                error: true,
                                msg: msg
                            }
                        };
                    }
                }
            }
        });

        if (Object.keys(errors).length > 0) {
            errorRef.current = errors;
            rendersRows.rows[rowIndex][0]();
            return false;
        }

        return true;
    };

    const esignData = () => {
        const value = {
            time: new Date().toISOString(),
            userData: getUserData(userData),
        };
        return value
    }

    const handleBtnClick = (event, row, rowIndex, column, columnIndex) => {
        if (event === "delete") {
            if (onDelete !== true) {
                const beforeDelete = !!onDelete?.before ? onDelete?.before : false
                const afterDelete = !!onDelete?.after ? onDelete?.after : false
                if (beforeDelete !== false) {
                    beforeDelete(deleteRow, cloneDeep(row), rowIndex)
                } if (afterDelete !== false) {
                    deleteRow(rowIndex)
                    afterDelete(cloneDeep(row), rowIndex)
                } else {
                    deleteRow(rowIndex)
                }
            } else {
                deleteRow(rowIndex)
            }
        } else if (event === "submit") {
            if (onSubmit?.checkESign == true) {
                let esignStatus = true
                columns?.forEach((col, i) => {
                    if (col?.type === "esign") {
                        const checkColData = (row?.[col?.uniqueName] !== "")
                            && (typeof row?.[col?.uniqueName] === "object")

                        if (!checkColData && (multipleESign === false)
                        ) {
                            esignStatus = false
                            showToast("E-Sign required", false)
                            return
                        } else if (
                            !checkColData && (multipleESign !== false) && (col?.eSignStep === row?.currentESignStep)
                        ) {
                            esignStatus = false
                            showToast(`E-Sign required in ${col?.name}`, false)
                            return
                        }
                    }
                })
                if (!esignStatus) {
                    return
                }
            }
            const isValidate = onSubmit?.checkValidation ? checkValidation(row, rowIndex) : true
            if (!isValidate) { return }
            if (onSubmit?.handler !== false) {
                onSubmit.handler(cloneDeep(row), rowIndex)
            } else {
                showToast("Submit function not provided !", false)
            }
        }
    }

    const helperUtils = (event, row, rowIndex) => {
        if (event === "checkValidation") {
            return checkValidation(row, rowIndex)
        } else if ("esignData") {
            return esignData()
        }
    }

    const hasEmptyValue = (obj) => {
        if (!obj || typeof obj !== "object") return true; // null, undefined, non-object are "empty"
    
        if (Object.keys(obj).length === 0) return true; // empty object is "empty"
    
        return Object.values(obj).some((val) => {
          if (val === undefined || val === null || val === "") return true;
          if (typeof val === "object") return hasEmptyValue(val); // recursive check
          return false;
        });
      };

    const changeRowDataOnDependencyFields = (activeRow, activeRowIndex, activeColumn, activeColumnIndex) => {
        const passData = {
            activeRow,
            activeRowIndex,
            activeColumn,
            activeColumnIndex,
        }
        rows?.forEach((r, ri) => {
            const updatedRowData = dependencyFields?.[activeColumn?.uniqueName]?.handler(
                cloneDeep({ ...passData, row: r, rowIndex: ri })
            ) // retunr obj with key ( column uniqueName ) : value ( as per column type )

            Object.keys(updatedRowData)?.forEach((uniqueName, i) => {
                if (Object.hasOwn(r, uniqueName) !== false) {
                    r[uniqueName] = updatedRowData?.[uniqueName]
                    renders?.rows?.[ri]?.[1]?.[uniqueName]()
                }
            })
        })
    }

    return (
        Array?.isArray(rows) ?
            (rows?.map((row, rowIndex) => {

                if (("isHeading" in row) && row.isHeading) {

                    let NewTitleActions = false
                    const colSpan = actions ? columns?.length + 1 : columns?.length
                    Object.keys(titleActions).forEach((key) => {
                        if (key === row?.uniqueName) {
                            const { handler = () => { } } = titleActions[key]
                            NewTitleActions = handler(
                                cloneDeep({
                                    rows,
                                    columns,
                                    currentRow: row,
                                    currentRowIndex: rowIndex,
                                }),
                                {
                                    allRow: render,
                                },
                                {
                                    rows,
                                    columns,
                                    currentRow: row,
                                    currentRowIndex: rowIndex,
                                }
                            )
                        }
                    })

                    return (
                        <TableRow key={`rowIndex-${rowIndex}`}>
                            <TableCell
                                colSpan={colSpan}
                                sx={{
                                    // border: '1px solid red',
                                    py: "10px",
                                }}
                            >
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                        display: 'flex',
                                        // border: '1px solid red'
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <Typography
                                            variant='h5'
                                        >
                                            {row?.title ?? "N/A"}
                                        </Typography>
                                    </Box>
                                    {
                                        NewTitleActions
                                            ? (
                                                <Box>
                                                    {NewTitleActions}
                                                </Box>
                                            )
                                            : null
                                    }

                                </Box>

                            </TableCell>
                        </TableRow>
                    )
                }

                if (("isHidden" in row) && (row?.isHidden)) {
                    return
                }

                return (
                    <TableRow key={`rowIndex-${rowIndex}`}>
                        <Row
                            row={row}
                            columns={columns}
                            renders={renders?.rows?.[rowIndex]}
                            rowIndex={rowIndex}
                            config={config}
                            errorRef={errorRef}
                            helperFunction={{
                                handleBtnClick,
                                helperUtils,
                                changeRowDataOnDependencyFields,
                                isISODateString,
                                removeMatchingItems,
                                hasEmptyValue
                            }}
                        />
                    </TableRow>
                )
            })
            ) : null
    )
}

export default Rows
